import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanLoad,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Route
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { RecaptchaPopupComponent } from '../components';
import { AuthService } from '~auth/services';

@Injectable()
export class CaptchaGuard implements CanActivate, CanLoad {

  private captchaModalRef: NgbModalRef;

  constructor(private modalService: NgbModal, private authService: AuthService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.authService.isAuthenticated()) {
      this.captchaModalRef = this.modalService.open(RecaptchaPopupComponent, {
        keyboard: false,
        backdrop: false,
        windowClass: 'modal-center captcha-modal'
      });
      return this.captchaModalRef.result
        .then((value) => {
          return value;
        }).catch(error => {
          console.log('ERROR', error);
        })
    }
    else {
      return true;
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/captcha/guards/captcha.guard.ts